var _circle, _circle2, _circle3, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPending(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 120,
    height: 120,
    viewBox: "0 0 120 120",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 60,
    cy: 60,
    r: 60,
    fill: "#532C10"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    opacity: 0.25,
    cx: 60.001,
    cy: 60,
    r: 50,
    fill: "#864C23"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 60,
    cy: 60,
    r: 36,
    fill: "#EC985B"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M73.3337 60.0003C73.3337 67.3641 67.3641 73.3337 60.0003 73.3337C52.6365 73.3337 46.667 67.3641 46.667 60.0003C46.667 52.6365 52.6365 46.667 60.0003 46.667C67.3641 46.667 73.3337 52.6365 73.3337 60.0003ZM58.3337 60.9626V54.0003H61.667V59.0381L66.6071 61.8903L64.9405 64.777L58.3337 60.9626Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPending);
export default __webpack_public_path__ + "static/media/pending.b2eb9ecd9ee9a1a2147e68c8087e9f4c.svg";
export { ForwardRef as ReactComponent };